import { render, staticRenderFns } from "./EntrancePage.vue?vue&type=template&id=1961b59d&scoped=true&"
import script from "./EntrancePage.vue?vue&type=script&lang=ts&"
export * from "./EntrancePage.vue?vue&type=script&lang=ts&"
import style0 from "./EntrancePage.vue?vue&type=style&index=0&id=1961b59d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1961b59d",
  null
  
)

export default component.exports